<div class="container-fluid d-flex flex-column overflow-auto h-100">
  <div class="row d-flex summary-view mx-2 mt-3">
    <div class="col-7 h-100 d-flex flex-column card-border">
      <div class="result-summary d-flex row">
        <div class="text-content d-flex flex-column">
          <span class="fst-italic mt-4 accello-general-text1">
            Latest Execution
          </span>

          <!-- Execution Time with Placeholder -->
          <span class="accello-general-text2 mt-3">
            <ng-container *ngIf="latestExecution; else loadingExecutionTime">
              {{ latestExecution?.startTime | customDateFormat }} -
              {{ latestExecution?.endTime | customDateFormat }}
            </ng-container>
          </span>
          <ng-template #loadingExecutionTime>
            <span class="placeholder col-6"></span>
          </ng-template>

          <!-- Execution Name with Placeholder -->
          <span class="placeholder-glow accello-general-text3 mt-2">
            <ng-container
              *ngIf="latestExecution?.name; else loadingExecutionName"
            >
              {{ latestExecution?.name }}
            </ng-container>
          </span>
          <ng-template #loadingExecutionName>
            <span class="placeholder col-4"></span>
          </ng-template>

          <!-- Execution Status with Placeholder -->
          <div class="status-card d-flex mt-2" [ngClass]="getStatus(latestExecution?.status)">
            <span
              class="accello-general-text4 mx-auto justify-content-center d-flex flex-column"
            >
              <ng-container
                *ngIf="latestExecution?.status; else loadingExecutionStatus"
              >
                {{ latestExecution?.status }}
              </ng-container>
            </span>
          </div>
          <ng-template #loadingExecutionStatus>
            <span class="placeholder col-3"></span>
          </ng-template>

          <span class="accello-general-text5 mt-3">Total Test Cases</span>

          <!-- Total Test Cases with Placeholder -->
          <span class="accello-header2 mt-2">
            <ng-container
              *ngIf="latestExecution?.totalCount; else loadingTestCases"
            >
              {{ latestExecution?.totalCount}}
            </ng-container>
          </span>
          <ng-template #loadingTestCases>
            <span class="placeholder col-2"></span>
          </ng-template>
        </div>

        <div class="chart-content">
          <span class="accello-general-text8 mt-2 d-flex justify-content-center"
            >Test Result Summary</span
          >
          <app-pie-chart class="test-result-summary"
            [chartType]="'doughnut'"
            [isLoading]="loading && !isIntervalLoading"
            [data]="currentSummaryChart.data"
            [backgroundColors]="currentSummaryChart.meta.backgroundColors"
            [meta]="currentSummaryChart.meta"
          ></app-pie-chart>
        </div>
      </div>
      <div class="card-summary d-flex row">
        @for (item of cardSummary; track $index) {
        <div
          class="col card-view d-flex flex-grow-1"
          [ngClass]="{ 'border-style': $index !== cardSummary.length - 1 }"
        >
          <div class="card-img mx-auto d-flex">
            <img class="status-img" [src]="item?.icon" />
          </div>
          <div class="card-text d-flex flex-column h-100 flex-grow-1">
            <div class="d-flex h-100 flex-column justify-content-end">
              <span class="accello-general-text6">{{ item?.summaryType }}</span>
            </div>
            <div class="d-flex h-100 flex-column justify-content-center">
              <span 
                class="accello-general-text7"
                [ngClass]="{ 'placeholder placeholder-glow col-6': item?.count == null }"
              >
                {{ item?.count ?? 0 }}
              </span>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="col card-border overall-summary">
      <span class="d-flex accello-general-text7 ms-4 mb-4 mt-4">Overall Test Result Summary</span>
      <app-pie-chart
        [chartType]="'doughnut'"
        [isLoading]="loading && !isIntervalLoading"
        [data]="overallSummaryChart.data"
        [backgroundColors]="overallSummaryChart.meta.backgroundColors"
        [meta]="overallSummaryChart.meta"
      ></app-pie-chart>
    </div>
  </div>
  <div class="flex-grow-1 mx-3">
    <div class="row d-flex justify-content-end">
      <div class="button-list py-3 d-flex justify-content-end gap-2">
        <button class="btn btn-accello-dark d-flex" (click)="refresh()">
          <mat-icon class="mat-icon">sync</mat-icon>
          <span class="m-auto">Refresh</span>
        </button>

        <button class="btn btn-accello-dark d-flex" [matMenuTriggerFor]="contextMenu" #menuTrigger="matMenuTrigger" (click)="onClickFilter()">
          <mat-icon>filter_alt</mat-icon>
          <span class="m-auto">Filter</span>
        </button>

        <button class="btn btn-accello-dark d-flex" (click)="delete()" [disabled]="selectedExecutions.length === 0">
          <mat-icon class="mat-icon">delete</mat-icon>
          <span class="m-auto">Delete</span>
        </button>

        <mat-menu #contextMenu="matMenu">
          <div
            class="menu-content-div"
            matMenuContent
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          >
            <span class="header-10">Filter</span>
            <app-dynamic-form
              [form]="filterForm"
              [formFields]="filterFields"
              (click)="$event.stopPropagation()" (modelChange)="onModelChange($event)"
              (keydown.enter)="$event.stopPropagation()"
            ></app-dynamic-form>
            <div class="d-flex justify-content-end gap-2 mt-3">
              <button
                class="btn  btn-accello-secondary"
                (click)="reset()"
              >
                Reset All
              </button>
              <button
                class="btn  btn-accello-primary-light" [disabled]="filterForm.invalid"
                (click)="filter()"
              >
                Filter
              </button>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
    <div class="row table-view">
      <app-zorro-table
        tableId="tc-exec-res"
        (handleActions)="onRowHandle($event)"
        [data]="executionList"
        [columns]="columns"
        [options]="{ expandable: true , isLazyLoad: true}"
        [isLoading]="loading"
        [meta]="meta"
        (onRowSelect)="handleRowSelect($event)"
        (pageChange)="onPageChange($event)"
      ></app-zorro-table>
    </div>
  </div>
</div>
